import React from "react";

const Feature = () => {
  return (
    
    <div className="container-fluid bg-light">
      <div className="container">

        <div className="row">

          {/* Left Content */}
          <div className="col-lg-7 mt-5 py-5 pr-lg-5">

            <h6 className="text-primary font-weight-normal text-uppercase">
              Why Choose Us?
            </h6>

            <h1 className="mb-4 section-title">
              10+ Years Experience In The Interior Design Industry
            </h1>

            <p className="mb-4">
              We create modern, functional, and elegant interior spaces that reflect style, comfort, and quality craftsmanship. Our team specializes in residential and commercial interior solutions, combining innovative design concepts with practical execution to deliver visually appealing and durable spaces.

            </p>

            <ul className="list-inline">

              <li>
                <h5>
                  <i className="far fa-check-square text-primary mr-3"></i>
                  10+ Years Experience
                </h5>
              </li>

              <li>
                <h5>
                  <i className="far fa-check-square text-primary mr-3"></i>
                  Best Interior Design
                </h5>
              </li>

              <li>
                <h5>
                  <i className="far fa-check-square text-primary mr-3"></i>
                  100% Turnkey Capability
                </h5>
              </li>

            </ul>

            <a href="#" className="btn btn-primary mt-3 py-2 px-4">
              View More
            </a>

          </div>

          {/* Right Image */}
          <div className="col-lg-5">

            <div className="d-flex flex-column align-items-center justify-content-center h-100 overflow-hidden">

              <img
                className="img-fluid"
                src="/img/feature.jpg"
                alt="Feature"
              />

            </div>

          </div>

        </div>

      </div>
    </div>
  );
};

export default Feature;